import { Endpoint } from './endpoints';
import { AUTH_ENV, BUNCHBALL_ENV, GRAPHQL_ENV } from '../environments';

export { buildUri } from './utils';
export { Endpoint } from './endpoints';

export const GRAPHQL_ENDPOINT = Endpoint.graphqlServer.build( GRAPHQL_ENV );
export const ID_ENDPOINT = Endpoint.id.build( AUTH_ENV );
export const CLOUDFRONT_ENDPOINT = Endpoint.cloudfront.build( GRAPHQL_ENV, true );
export const BUNCHBALL_ENDPOINT = Endpoint.bunchball.build( BUNCHBALL_ENV );